import { createContext } from 'react';

import type { useBrand } from '../hooks/useBrand';

/** Internal context shared by the feature's provider and public hook. */
export const BrandContext = createContext<useBrand.Return | null>(null);
